import React, { FunctionComponent, useEffect } from 'react';
import FocusLock from 'react-focus-lock';
import ReactDOM from 'react-dom';
import './_modal.scss';
import Exclamation from '@/assets/Exclamation.svg';

export interface ModalProps {
  isShown: boolean;
  hide: any;
  modalContent: JSX.Element;
  headerText?: string;
  errorModal?: boolean;
}

export const Modal: FunctionComponent<ModalProps> = ({
  isShown,
  hide,
  modalContent,
  headerText,
  errorModal
}) => {
  const onKeyDown = (event: KeyboardEvent) => {
    if (event.keyCode === 27 && isShown) {
      hide();
    }
  };

  useEffect(() => {
    isShown ? (document.body.style.overflow = 'hidden') : (document.body.style.overflow = 'unset');
    document.addEventListener('keydown', onKeyDown, false);
    return () => {
      document.removeEventListener('keydown', onKeyDown, false);
    };
  }, []);

  const modal = (
    <>
      <div className="modal__backdrop" onClick={hide} />
      <FocusLock>
        <div
          className="modal__wrapper"
          aria-modal
          aria-labelledby={headerText}
          tabIndex={-1}
          role="dialog"
        >
          <div className={`modal__content ${errorModal && 'p-3 p-lg-4'}`}>
          {!errorModal ? 
            <div className="modal__header">
              <div className="modal__header__text">{headerText}</div>
              <button className="modal__header__button" onClick={hide}></button>
            </div> : 
            <div className="d-flex align-items-center flex-column">
            <Exclamation/>
            <h2 className="text-center m-0 p-3">{headerText}</h2>
            </div>}
            <div className="modal__body-text">{modalContent}</div>
          </div>
        </div>
      </FocusLock>
    </>
  );

  return isShown ? ReactDOM.createPortal(modal, document.body) : null;
};

export default Modal;
